import * as Web from './CommandServiceDtos.generated';
import * as Search from './framework/searchObjects';
import { ValidationResult } from './framework/validationResult';
import { CommandResponse, CommandResponseTyped } from './framework/commandResponse';
import { CloseAndRefreshDto } from './framework/closeAndRefreshDto';
import { IdStatusDto } from './framework/IdStatusDto';
import { ISearchGridFormat } from './framework/IsearchGridFormat';
import { ICellLink } from './framework/IcellLink';
import { ILink } from './framework/Ilink';

export {
    Web,
    Search,
    ValidationResult,
    CommandResponse,
    CommandResponseTyped,
    CloseAndRefreshDto,
    IdStatusDto,
    ICellLink,
    ILink,
    ISearchGridFormat
};